export interface IRating {
  id: number;
  name: string;
  displayOrder: number | null;
  active: boolean | null;
  overriddenBy: number | null;
  testMinCrew: number | null;
  testMaxCrew: number | null;
  testable: boolean | null;
  category: string | null;
  programId: number | null;
}

export class Rating implements IRating {
  id;
  name;
  displayOrder;
  active;
  overriddenBy;
  testMinCrew;
  testMaxCrew;
  testable;
  category;
  programId;

  constructor(config: IRating) {
    this.id = config.id;
    this.name = config.name;
    this.displayOrder = config.displayOrder;
    this.active = config.active;
    this.overriddenBy = config.overriddenBy;
    this.testMinCrew = config.testMinCrew;
    this.testMaxCrew = config.testMaxCrew;
    this.testable = config.testable;
    this.category = config.category;
    this.programId = config.programId;
  }
}
